import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/neighborhoodsDetailsPage/NeighborhoodsDetailsComponent.tsx");
